/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect } from "react";
import PropTypes from "prop-types";

import { AV_VALUES, DIR_VALUES } from "constants/common";

const RoutesTable = ({
  isLoading,
  relevantBusRoutes,
  showingSearchResult = false,
}) => {
  const onRouteClickHandler = (e) => {
    e.stopPropagation();
    localStorage.setItem("scrollPos", window.scrollY);
    const enclosingDiv = e.target.closest("[data-route-num]");

    const routeParams = new URLSearchParams({
      route_category: enclosingDiv.getAttribute("data-route-category"),
      route_num_name: enclosingDiv.getAttribute("data-route-num"),
      bound_dir: enclosingDiv.getAttribute("data-route-dir"),
    });

    window.location.href = `/vehicle-route-details?${routeParams.toString()}`;
  };

  const getDir = (busRoute) => {
    if (busRoute?.flip) {
      return busRoute?.bound_dir === "U" ? "D" : "U";
    }
    return busRoute?.bound_dir;
  };

  useEffect(() => {
    const pageLoc = localStorage.getItem("scrollPos");

    if (pageLoc && !isLoading) {
      window.scrollTo({
        top: parseInt(pageLoc),
        left: 0,
      });
    }
  });

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 md:gap-4 drop-shadow-lg rounded-md mb-12"
      onClick={(e) => onRouteClickHandler(e)}
    >
      {relevantBusRoutes.map((busRoute) => (
        <div
          key={`${busRoute.route_num_name}__${busRoute.route_category}`}
          className="gap-4 p-6 bg-accent-back my-5"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            onRouteClickHandler(e);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onRouteClickHandler(e);
            }
          }}
          data-route-num={busRoute.route_num_name}
          data-route-category={busRoute.route_category}
          data-route-dir={getDir(busRoute)}
        >
          {showingSearchResult && (
            <div className="text-sm text-slate-400 mb-5">
              {busRoute.route_category}
            </div>
          )}
          <div className="grid grid-cols-[2fr_1fr] mb-4">
            <span className="align-top hover:text-rose-700 font-fam-hind tracking-wide text-2xl">
              {busRoute.route_num_name}
            </span>

            <div className="flex flex-col text-sm justify-self-end text-right text-rose-700">
              <span>{DIR_VALUES[getDir(busRoute)]}</span>
              <span>{AV_VALUES[busRoute.availability]}</span>
            </div>
          </div>

          <div className="flex flex-col text-base gap-3">
            <span>
              {busRoute?.flip ? busRoute.destination_2 : busRoute.destination_1}
            </span>
            <span>
              {busRoute?.flip ? busRoute.destination_1 : busRoute.destination_2}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

RoutesTable.propTypes = {
  isLoading: PropTypes.bool,
  showingSearchResult: PropTypes.bool,
  relevantBusRoutes: PropTypes.object,
};

export default RoutesTable;
